export default {
  '4.5': '1.125rem',
}
